import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pipeTransform'
})
export class Pipe1Pipe implements PipeTransform {
  /**
   * @ignore
   */
  transform(): null {
    return null;
  }
}
